import { render, staticRenderFns } from "./VirtualAccountTransactionListView.vue?vue&type=template&id=9852079e&"
import script from "./VirtualAccountTransactionListView.vue?vue&type=script&lang=js&"
export * from "./VirtualAccountTransactionListView.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAccountTransactionListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports